/**
 * Sly item Navigator
 *
 * @package Embark
 * @since   1.0.0
 */

import $ from 'jquery';
import * as helpers from '../global/helpers';

const slyInit = () => {
	var $frame  = $('#project-slider');
	var $slidee = $frame.children('ul').eq(0);
	var $wrap   = $frame.parent();
	
	// Call Sly on frame
	$frame.sly({
		horizontal: 1,
		itemNav: 'centered',
		smart: 1,
		activateOn: 'click',
		mouseDragging: 1,
		touchDragging: 1,
		releaseSwing: 1,
		startAt: 0,
		scrollBar: $wrap.find('.scrollbar'),
		scrollBy: 1,
		speed: 300,
		elasticBounds: 1,
		dragHandle: 1,
		dynamicHandle: 1,
		clickBar: 1,

		// Buttons
		prev: $wrap.find('.prev-page'),
		next: $wrap.find('.next-page')
	},
);

	$frame.sly('reload');

}

window.addEventListener('load', slyInit);
window.addEventListener('resize', () => {
	var $frame  = $('#project-slider');
	helpers.debounce($frame.sly('reload'));
});